import React, { Suspense, lazy } from 'react'

const LazyImport = (Component) => {
  const ComponentLoadable = lazy(Component)
  return props => (
    <Suspense fallback={<div />}>
      <ComponentLoadable {...props} />
    </Suspense>
  )
}

export default LazyImport
